import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "transitioning"],
  _excluded2 = ["align", "duration", "Wrapper"];
import styled from 'styled-components';
import TwoWayTransition from 'UIComponents/transitions/TwoWayTransition';
import { jsx as _jsx } from "react/jsx-runtime";
const slideAxis = align => align === 'top' || align === 'bottom' ? 'translateY' : 'translateX';
const slideDirection = align => align === 'bottom' || align === 'right' ? '(100%)' : '(-100%)';
const MobilePanelTransitionWrapper = styled(_ref => {
  let {
      open,
      transitioning
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TwoWayTransition.PlainWrapper, Object.assign({
    "data-component-name": "UIPanel",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "MobilePanelTransition__MobilePanelTransitionWrapper",
  componentId: "sc-24034h-0"
})(["transition-property:", ";transition-duration:", "ms;transform:", ";position:fixed;top:0;bottom:0;z-index:1211;width:100%;"], ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', ({
  duration
}) => duration, ({
  open,
  align
}) => {
  if (open) return `${slideAxis(align)}(0%)`;
  return `${slideAxis(align)}${slideDirection(align)}`;
});
export default function MobilePanelTransition(_ref2) {
  let {
      align = 'right',
      duration = 150,
      Wrapper = MobilePanelTransitionWrapper
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, rest, {
    duration: duration,
    align: align,
    Wrapper: Wrapper,
    transitionOnMount: true
  }));
}